import { getDisplayObjectBounds } from "./getObjectBounds";

function isDrawingInstruction(instruction: any) {
    return Object.keys(instruction).length > 0 && instruction.x !== undefined && instruction.y !== undefined;
}

function getRoundRectInstructions(value: createjs.DisplayObject): Object[] {
    let bounds = getDisplayObjectBounds(value);
    let radius = isNaN((value as any).useAsMaskCornerRadius) ? 7 : (value as any).useAsMaskCornerRadius;
    let width =  value.parent ? value.parent.scaleX * value.width : value.width;
    let height = value.parent ? value.parent.scaleY * value.height : value.height;
    return [new createjs.Graphics.RoundRect(bounds.x + value.x,
        bounds.y + value.y,
        width,
        height,
        radius,
        radius,
        radius,
        radius)];
}

export function getGraphicsInstructions(value: createjs.DisplayObject): Object[] {
    if (value instanceof createjs.Shape) {
        return (value.graphics as any)._instructions.filter((instruction: any) => {
            return isDrawingInstruction(instruction);
        });
    } else {
        return getRoundRectInstructions(value);
    }
}
